<template>
    <div class="head">
        <div class="headTop">
            <div class="headBoxLeft" @click="backHome()">智慧巡检系统总后台</div>
            <div class="headBoxRight">
                <div class="box userName">{{ userName }}</div>
                <div class="box logOutBtn" @click="logOut">退出</div>
            </div>
        </div>
        <div class="headLeft">
            <div class="menu">
                <div
                    class="menuSon"
                    v-for="(item, key) in menuData"
                    :key="key"
                    :class="[item.checketFlag ? 'menuChecket' : '']"
                    @click="pageTo(key)"
                >
                    {{ item.title }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { removeCookie } from "../untils/tools";

export default {
    name: "headView",
    data() {
        return {
            menuData: [
                {
                    title: "机构列表",
                    checketFlag: false,
                },
                {
                    title: "新建机构",
                    checketFlag: false,
                },
            ],

            userName: ''
        };
    },
    props: {
        showStyle: {
            type: [Number, String],
            default: -1
        },
    },

    created() {
        // this.goOut();
    },

    mounted() {
        this.userName = localStorage.getItem('userName')
        if (this.showStyle != undefined && this.showStyle != -1) {
            this.menuData[this.showStyle]['checketFlag'] = true
        }
    },

    methods: {
        logOut() {
            removeCookie();
            this.$router.replace("/login");
        },

        pageTo(key) {
            switch (key) {
                case 0:
                    this.$router.push('/institutionList')
                    break;
                case 1:
                    this.$router.push('/institutionAdd')
                    break;
            }
        },

        backHome () {
            this.$router.push('/')
        },

        goOut() {
            if (!getCookie()) {
                this.$message({
                    type: "warning",
                    message: "登录过期，请重新登录！",
                });
                //
                return setTimeout(() => {
                    this.$message.closeAll();
                    this.$router.replace("/login");
                }, 1000);
            }
            this.getStatisticsInit()
        },
    },
};
</script>

<style lang="less" scoped>
.head {
    position: relative;
    width: 100%;

    .headTop {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 56px;
        color: rgba(25, 137, 250, 1);
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px rgba(0, 21, 41, 0.12);
        z-index: 99;

        .headBoxLeft {
            margin-left: 16px;
            float: left;
            width: 300px;
            height: 56px;
            line-height: 56px;
            text-align: left;
            color: rgba(25, 137, 250, 1);
            letter-spacing: 2px;
            font-size: 18px;
            font-weight: 700;
            cursor: pointer;
        }

        .headBoxRight {
            margin-top: calc((56px - 32px) / 2);
            display: flex;
            flex-direction: row;
            float: right;
            margin-right: 24px;
            width: 163px;
            height: 32px;
            line-height: 32px;
            text-align: center;

            .userName {
                width: 90px;
                height: 30px;
                color: rgba(25, 137, 250, 1);
                font-size: 20px;
                font-weight: 400;
            }

            .logOutBtn {
                width: 73px;
                height: 32px;
                color: #fff;
                background-color: rgba(102, 177, 255, 1);
                border-radius: 4px;
                cursor: pointer;
            }
        }
    }

    .headLeft {
        position: absolute;
        left: 0px;
        top: 0;
        width: 210px;
        height: 100vh;
        background: rgba(51, 65, 84, 1);
        mix-blend-mode: normal;
        z-index: 98;
        overflow: hidden;
        .menu {
            margin-top: 56px;

            .menuSon {
                padding-left: 30px;
                width: 210px;
                height: 56px;
                color: rgba(192, 196, 204, 1);
                font-size: 14px;
                line-height: 56px;
                font-weight: 400;
                cursor: pointer;
            }

            .menuSon:hover {
                color: rgba(25, 137, 250, 1);
                background-color: rgba(34, 45, 60, 1);
            }

            .menuChecket {
                color: rgba(25, 137, 250, 1);
                background-color: rgba(34, 45, 60, 1);
            }
        }
    }
}
</style>